import { render, staticRenderFns } from "./EntityNewsStatistics.vue?vue&type=template&id=bedb4a92&scoped=true"
import script from "./EntityNewsStatistics.vue?vue&type=script&lang=js"
export * from "./EntityNewsStatistics.vue?vue&type=script&lang=js"
import style0 from "./EntityNewsStatistics.vue?vue&type=style&index=0&id=bedb4a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedb4a92",
  null
  
)

export default component.exports